import { AppDispatch, GetState, RootState } from '../store';
import { changeStep, Step } from '../slices/step.slice';
import { selectLongTermJWT } from '../slices/session.slice';
import { selectReportStatus } from '../slices/report.slice';
import { isPersonaInformationPrefilled } from './init-current-step';

export const completeEmailVerification = () => {
	return (dispatch: AppDispatch, getState: GetState): void => {
		const state = getState();
		updateUrlWithToken(state);
		const nextStep = determineNextStep(state);
		dispatch(changeStep(nextStep));
	};
};

function updateUrlWithToken(state: RootState): void {
	const token = selectLongTermJWT(state);
	window.history.pushState({}, '', `/${token}`);
}

function determineNextStep(state: RootState): Step {
	const status = selectReportStatus(state);

	if (status === 'NO_PHONE_NUMBER') {
		return 'PHONE_NUMBER_INPUT_STEP';
	}

	return isPersonaInformationPrefilled(state) ? 'PERSONA_CONSENT_INPUT_STEP' : 'PERSONA_INFORMATION_INPUT_STEP';
}
